import React, { useMemo } from "react";
import { View, Image, StyleProp, ViewStyle } from "react-native";
import { useTheme } from "arkh";

export enum TaskTypeIconSize {
  XXSMALL = 15,
  XSMALL = 25,
  SMALL = 30,
  BIG = 60,
}

const assetPath = "../assets/images/apps/ROUTINES/tasks/";

export type TaskTypeIconOptions =
  | {
      __typename: "TaskNumber";
      unit?: "CUSTOM" | "CURRENCY";
    }
  | {
      __typename: "TaskCheck";
      sentiments?: ("POSITIVE" | "NEGATIVE" | "NEUTRAL")[];
    }
  | { __typename: "TaskText" };

export const TaskTypeIcon = ({
  type,
  size = TaskTypeIconSize.BIG,
  style,
}: {
  type: TaskTypeIconOptions;
  size?: TaskTypeIconSize;
  style?: StyleProp<ViewStyle>;
}) => {
  const theme = useTheme();

  const typeProperties = useMemo(() => {
    switch (type.__typename) {
      case "TaskCheck": {
        if (
          type?.sentiments?.length === 2 &&
          type.sentiments.includes("POSITIVE") &&
          type.sentiments.includes("NEGATIVE")
        ) {
          return {
            color: theme.positive,
            // eslint-disable-next-line @typescript-eslint/no-require-imports
            source: require(`${assetPath}toggle.png`),
          };
        }
        return {
          color: theme.positive,
          // eslint-disable-next-line @typescript-eslint/no-require-imports
          source: require(`${assetPath}check.png`),
        };
      }
      case "TaskText":
        return {
          color: theme.colorScheme[4],
          // eslint-disable-next-line @typescript-eslint/no-require-imports
          source: require(`${assetPath}text.png`),
        };
      case "TaskNumber": {
        if (type?.unit === "CURRENCY") {
          return {
            color: theme.colorScheme[3],
            // eslint-disable-next-line @typescript-eslint/no-require-imports
            source: require(`${assetPath}number.png`),
          };
        }
        return {
          color: theme.colorScheme[3],
          // eslint-disable-next-line @typescript-eslint/no-require-imports
          source: require(`${assetPath}number.png`),
        };
      }
      default:
        throw Error("TaskUIType not implemented");
    }
  }, [theme.colorScheme, theme.positive, type]);

  return (
    <View
      style={[
        {
          height: size,
          width: size,
          justifyContent: "center",
          alignItems: "center",
          borderRadius: 5,
          backgroundColor: typeProperties.color,
        },
        style,
      ]}
    >
      <Image
        style={{
          height: Math.round(size * 0.8),
          width: Math.round(size * 0.8),
        }}
        resizeMode="contain"
        source={typeProperties.source}
      />
    </View>
  );
};
